<template>
  <input-widget type="select2" :attribute="attribute" :items="items" :search-handler="handler"
    :display-field="displayFieldFunction" :display-field-for-selection="displayFieldFunctionForSelection"
    :value-field="valueField" :disabled="disabled" :hint="hint" :rules="rules" :model="model" :label="label"
    :options="options" @select2Select="onSelect" @select2Unselect="onUnselect" :multiple="multiple"/>
</template>


<script>
  import InputWidget from "../components/input-widget/InputWidget";
  import SalesService from "../../modules/sales/SalesService";
  import {Formatter} from "@/core/services/formatter.service";

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "SaleSelectInputWidget",
    components: {InputWidget},
    props: {
      model: {
        type: Object,
        required: true
      },
      attribute: {
        type: String,
        required: true
      },
      items: {
        type: Array,
        default: () => []
      },
      hint: {
        type: [Boolean, String],
        default: false
      },
      valueField: {
        type: String,
        default: 'uuid'
      },
      disabled: {
        type: Boolean,
        default: false
      },
      label: {
        type: [Boolean, String],
        default: null
      },
      options: {
        type: Object,
        default: () => {
          return {};
        }
      },
      rules: {
        type: String,
        default: null,
        required: false
      },
      expand: {
        type: String,
        default: 'currency',
      },
      latestReceiptUuids: {
        type: Array,
        default: () => [],
      },
      removeTitleFromSelection: {
        type: Boolean,
        default: false
      },
      removeTitleFromSearch: {
        type: Boolean,
        default: false
      },
      removeDuplicates: {
        type: Boolean,
        default: false
      },
      multiple: {
        type: Boolean,
        default: false
      },
      status: {
        type: String,
        default: null,
      },
      type: {
        type: String,
        default: null,
      },
    },
    methods: {
      displayFieldFunction(item) {
        if (this.removeTitleFromSearch) {
          return `${item.sale_no}`
        }
        let title = this.$options.filters.truncate(this.$options.filters.striptags(Formatter.getByMasterLanguage(item.title)), 50)
        return `${item.sale_no} - ${title}`
      },
      displayFieldFunctionForSelection(item) {
        if (this.removeTitleFromSelection) {
          return `${item.sale_no}`
        }
        let title = this.$options.filters.truncate(this.$options.filters.striptags(Formatter.getByMasterLanguage(item.title)), 50)
        return `${item.sale_no} - ${title}`
      },
      async handler(search) {
        let params = {
          search,
          expand: this.expand,
          ordering: '-start_date',
        }
        if (this.latestReceiptUuids && this.latestReceiptUuids.length > 0) {
          params.latest_receipt_uuid = this.latestReceiptUuids.join(',')
        }
        if (this.status) {
          params.status = this.status
        }
        if (this.type) {
          params.type = this.type
        }
        let response = await SalesService.getSales(params);

        if (!response.success) {
          return response
        }

        if (this.removeDuplicates && this.multiple && this.model[this.attribute] && this.model[this.attribute].length > 0) {
          const tmpStr = this.model[this.attribute].join('|')
          response.body.results = response.body.results.filter(r => !tmpStr.includes(r.uuid))
        }

        return response;
      },
      updateItems() {
        if (this.items.length) {
          return;
        }

        // TODO add check with uuid dynamic
        if (this.model.auction && this.model.auction_uuid === this.model[this.attribute]) {
          this.items.push(this.model.auction);
        }

        this.$watch(`model.auction`, function () {
          // TODO add check with uuid dynamic
          if (this.model.auction && this.model.auction_uuid === this.model[this.attribute]) {
            this.items.push(this.model.auction);
          } else if (!this.model.auction_uuid) {
            if (this.isSearch) {
              this.items.splice(0, this.items.length);
            } else {
              this.items.length = 0;
            }
          }
        }, {deep: true});
      },
      onSelect(data) {
        this.$emit('select', data);
      },
      onUnselect() {
        this.$emit('unselect');
      }
    },
    mounted() {
      this.updateItems();
    }
  }
</script>

<style scoped>

</style>
